import PropTypes from "prop-types";
import clsx from "clsx";
import { formatExternalUrl } from "../../helpers/utils";
import ImageLoader from "../ImageLoader";

const BrandLogoOneSingle = ({ data, spaceBottomClass }) => {
    return (
        <div className={clsx("single-brand-logo", spaceBottomClass)}>
            {/* <img
                src={formatExternalUrl(data.image)}
                alt=""
                style={{
                    aspectRatio: 1,
                    objectFit: "contain",
                    width: 180
                }}
            /> */}
            <ImageLoader
                src={formatExternalUrl(data.image)}
                alt={data.title}
                style={{
                    aspectRatio: 1,
                    objectFit: "contain",
                    width: 90,
                    margin: 'auto'
                }}
                width={90}
                height={90}
            />
        </div>
    );
};

BrandLogoOneSingle.propTypes = {
    data: PropTypes.shape({}),
    spaceBottomClass: PropTypes.string,
};

export default BrandLogoOneSingle;
